import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "../context/ToastContext";
import { useCurrentDevice } from "../context/CurrentDeviceContext";
import { sendEmail } from "../util/EmailHandler";
import { sendAlarmOffline } from "../Api";
import { Nav } from "rsuite";
import { Icon } from "@rsuite/icons";
import { IoCloudOfflineOutline } from "react-icons/io5";
import { BsCpu } from "react-icons/bs";
import { CgSmartphoneRam } from "react-icons/cg";
import { RequestShellDevice } from "../models/RequestShellDevice";
import { useAuth } from "../context/AuthContext";
import "./DeviceMenu.css";

const AlarmsMenu = ({ x, y }) => {
  const { currentDevice: deviceSelected } = useCurrentDevice();
  const { user } = useAuth();
  const [t] = useTranslation();
  const [showMenu, setShowMenu] = useState(false);
  const menuItemOpened = useRef(false);
  const menuClick = useRef(false);
  const toast = useToast();

  useEffect(() => {
    const handleClick = () => {
      if (!menuClick.current) setShowMenu(false);
      else {
        if (!menuItemOpened.current) menuClick.current = false;
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (deviceSelected != null && deviceSelected.id) setShowMenu(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceSelected]);

  function alarmForRamHandler() {
    sendEmail(
      user?.email,
      t("alarms-menu.your-ram-memory-is-full")
    ).then((response) => {
      if (response)
        toast.success(
          t("alarms-menu.alarm-sent-for-ram"),
          t("alarms-menu.alarm-notification")
        );
      else
        toast.error(
          t("alarms-menu.alarm-could-not-be-sent"),
          t("alarms-menu.alarm-notification")
        );
    });
  }

  function alarmForCpuHandler() {
    sendEmail(
      user?.email,
      t("alarms-menu.your-cpu-memory-is-full")
    ).then((response) => {
      if (response)
        toast.success(
          t("alarms-menu.alarm-sent-for-cpu"),
          t("alarms-menu.alarm-notification")
        );
      else
        toast.error(
          t("alarms-menu.alarm-could-not-be-sent"),
          t("alarms-menu.alarm-notification")
        );
    });
  }

  function sendRequestForOffline() {
    const requestShellDevice = new RequestShellDevice(
      deviceSelected.id,
      deviceSelected.sysname,
      deviceSelected.usrname
    );
    sendAlarmOffline(requestShellDevice).then((response) => {
      console.log(response);
    });
  }

  function alarmForOfflineHandler() {
    sendRequestForOffline();
    sendEmail(
      user?.email,
      t("alarms-menu.your-are-offline-check-your-internet-connection")
    ).then((response) => {
      if (response)
        toast.success(
          t("alarms-menu.alarm-sent-for-offline"),
          t("alarms-menu.alarm-notification")
        );
      else
        toast.error(
          t("alarms-menu.alarm-could-not-be-sent"),
          t("alarms-menu.alarm-notification")
        );
    });
  }

  return (
    <>
      {showMenu && deviceSelected != null && (
        <Nav
          vertical
          className="content content-final nav-menu"
          style={{ top: y, left: x }}
          id="alarm-menu"
          onClick={() => (menuClick.current = true)}
        >
          <Nav.Item
            icon={<Icon as={CgSmartphoneRam} />}
            onClick={alarmForRamHandler}
          >
            {t("alarms-menu.alarm-for-ram")}
          </Nav.Item>
          <Nav.Item icon={<Icon as={BsCpu} />} onClick={alarmForCpuHandler}>
            {t("alarms-menu.alarm-for-cpu")}
          </Nav.Item>
          <Nav.Item
            icon={<Icon as={IoCloudOfflineOutline} />}
            onClick={alarmForOfflineHandler}
          >
            {t("alarms-menu.alarm-for-offline")}
          </Nav.Item>
        </Nav>
      )}
    </>
  );
};

export default AlarmsMenu;
